import React, { useState, FC, useCallback } from "react";

import { useMatchParams } from "kanopi-components/hooks/useMatchParams";
import { quoteFlowFields } from "kw/api/fragments";
import {
  QuestionFlowComponent,
  QuestionFlowTypeEnum,
} from "kw/components/QuestionFlow/QuestionFlowComponent";

type TCoverFlow = {
  coverId: string;
  riskProfileId: string;
  prefix: string;
  coverEnabled: boolean;
  policyId: string;
  finishedRoute?: string;
  onComplete: (...args: unknown[]) => void;
};

export const CoverFlow: FC<TCoverFlow> = ({
  coverId,
  riskProfileId,
  prefix,
  coverEnabled,
  policyId,
  finishedRoute = prefix,
  onComplete,
}) => {
  const { questionSetKey } = useMatchParams(`${prefix}/:questionSetKey`);
  const startCoverQuery = {
    startCover: [
      {
        input: {
          coverId,
          riskProfileId,
          questionSetKey,
        },
      },
      { ...quoteFlowFields },
    ],
  };
  const [currentMaxSet, setCurrentMaxSet] = useState({
    currentSet: 0,
    maxSets: 1,
  });
  const [nextButtonText, setNextButtonText] = useState<string>();
  const onQuestionFlowFinish = useCallback(async () => {
    await onComplete?.();
  }, []);

  const onCurrentMaxSetChange = (currentSet, maxSets) => {
    const _totalSets = { ...currentMaxSet };
    _totalSets.currentSet = !questionSetKey && currentSet === maxSets ? 0 : currentSet;
    _totalSets.maxSets = maxSets;
    setCurrentMaxSet(_totalSets);
    const _nextButtonText =
      currentSet === maxSets - 1
        ? coverEnabled
          ? "Update cover"
          : "Add cover"
        : undefined;
    setNextButtonText(_nextButtonText);
  };
  return (
    <QuestionFlowComponent
      isFlowLayout={false}
      actionFlowType={
        policyId ? QuestionFlowTypeEnum.Update : QuestionFlowTypeEnum.Quote
      }
      prefix={prefix}
      finishedRoute={finishedRoute}
      defaultBackLocation=""
      actionQuery={startCoverQuery}
      questionFlowResponseKey="startCover"
      questionSetKey={questionSetKey}
      onCurrentAndMaxSetChange={onCurrentMaxSetChange}
      nextButtonText={nextButtonText}
      onQuestionFlowFinish={onQuestionFlowFinish}
    />
  );
};
